import * as React from 'react';

export const useDownloadFile = () => {
  const iframeRef = React.useRef<HTMLIFrameElement | null>(null);

  const download = (link: string) => {
    if (!iframeRef.current) {
      iframeRef.current = document.createElement('iframe');
      iframeRef.current.style.width = String(0);
      iframeRef.current.style.height = String(0);
      iframeRef.current.style.border = String(0);
      iframeRef.current.style.display = 'block';
      document.body.appendChild(iframeRef.current);
    }
    iframeRef.current.src = link;
  };

  return download;
};
